import React from 'react';

import { HeightOutlined } from '@mui/icons-material';

import createBlockInputSection from './helpers/createBlockInputSection';
import HideSectionInput from './special-inputs/HideSectionInput';

const SpacerSidebarForm = createBlockInputSection({
  title: 'Spacer block',
  inputs: [
    {
      type: 'slider',
      props: {
        name: 'height',
        label: 'Height',
        iconLabel: <HeightOutlined sx={{ color: 'text.secondary' }} />,
        units: 'px',
        step: 4,
        min: 4,
        max: 128,
      },
    },
    HideSectionInput,
  ],
});

export default SpacerSidebarForm;
